<div class="main-page">
    <form (ngSubmit)="forgotten()" [formGroup]="contactForm">
        <label for="email">Email</label>
        <input type="email" formControlName="email" placeholder="email...">
        <button type="submit" class="btn-red">Recuperar contraseña</button>
    </form>
    <div class="modal-question">
        <p class="m-auto">¿Ya la has recuperado? <a (click)="modalService._type='login'" class="alt">Login</a></p>
    </div>
</div>